// src/pages/AdminPage.js
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Card, Col, Row } from "react-bootstrap";
import { AuthContext } from "../AuthContext";

const ADMIN_CARDS = [
  {
    key: "users",
    icon: "bi-people-fill",
    title: "Users",
    description: "Manage user accounts and passwords.",
    adminOnly: true,
    to: "/admin/users",
  },
  {
    key: "roles",
    icon: "bi-shield-lock-fill",
    title: "Roles",
    description: "Assign and manage roles for each user.",
    adminOnly: true,
    to: "/admin/roles",
  },
  {
    key: "services",
    icon: "bi-clipboard2-check-fill",
    title: "Services",
    description: "Add, edit, or disable service types.",
    adminOnly: true,
    to: "/admin/services",
  },
  {
    key: "mentors",
    icon: "bi-person-heart",
    title: "Mentors",
    description: "Add and manage Navigation program mentors.",
    adminOnly: false,
    to: "/admin/mentors",
  },
  {
    key: "contact-types",
    icon: "bi-tags-fill",
    title: "Contact Types",
    description: "Manage the Address Book type list (gas, pantries, state services, etc.).",
    adminOnly: true,
    to: "/admin/contact-types",
  },
  {
    key: "gas-propane",
    icon: "bi-fire",
    title: "Gas & Propane Locations",
    description: "Manage gas stations and propane refill/exchange locations.",
    adminOnly: true,
    to: "/admin/gas-propane",
  },
  {
    key: "provider-locations",
    icon: "bi-building",
    title: "Provider Locations",
    description: "Manage service provider locations.",
    adminOnly: true,
  },
  {
    key: "food-pantries",
    icon: "bi-basket-fill",
    title: "Food Pantries",
    description: "Manage food pantry locations and details.",
    adminOnly: true,
  },
  {
    key: "beds",
    icon: "bi-house-fill",
    title: "Beds",
    description: "Manage bed inventory and availability.",
    adminOnly: true,
    to: "/admin/beds",
  },
  {
    key: "laundry-ministry",
    icon: "bi-basket2-fill",
    title: "Laundry Ministry",
    description: "Configure the partner laundromat, city, color, and contact details.",
    adminOnly: true,
    to: "/admin/laundry-ministry",
  },
];

export default function AdminPage() {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  const isAdmin     = user?.roles?.includes("ADMIN") || user?.roles?.includes("DIRECTOR");
  const isNavigator = user?.roles?.includes("NAVIGATOR");

  if (!isAdmin && !isNavigator) {
    return <Alert variant="danger" className="m-3">You do not have permission to view this page.</Alert>;
  }

  const visible = ADMIN_CARDS.filter((c) => isAdmin || !c.adminOnly);

  return (
    <div className="p-3">
      <h3 className="mb-4">
        <i className="bi bi-gear-fill me-2" />
        Admin
      </h3>

      <Row className="g-3">
        {visible.map(({ key, icon, title, description, to }) => (
          <Col key={key} xs={12} sm={6} lg={4} xl={3}>
            <Card
              className="h-100"
              style={{ cursor: to ? "pointer" : "default" }}
              onClick={to ? () => navigate(to) : undefined}
            >
              <Card.Body>
                <div className="mb-2">
                  <i className={`bi ${icon}`} style={{ fontSize: "1.5rem" }} />
                </div>
                <Card.Title className="mb-1">{title}</Card.Title>
                <Card.Text className="text-muted" style={{ fontSize: "0.875rem" }}>
                  {description}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
}
